import React, { useEffect, useState } from "react";
import * as api from "../constant/API";
import { all_routes } from "../router/all_routes";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button } from "react-bootstrap";

const InternalUserReport = () => {

    const routes = all_routes;
    const roleId = localStorage.getItem('RoleId');

    const [designationList, setDesignationList] = useState([]);
    const [getAllUserList, setGetAllUserList] = useState([]);
    const [designationId, setDesignationId] = useState('')
    const [showTable, setShowTable] = useState(false);

    useEffect(() => {
        getList();
    }, [])

    function getList() {
        const getdata = api.GetData;
        fetch(getdata, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((lstResponse) => lstResponse.json())
            .then((lstResult) => {
                if (lstResult.error == false) {
                    setDesignationList(lstResult.data)
                }
                else {
                    Swal.fire(lstResult.message)
                    if (lstResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
    }

    function getUserData(desig: string) {
        const getallusrdata = api.GetAllUserData + '/' + desig;
        fetch(getallusrdata, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((userResponse) => userResponse.json())
            .then((userResult) => {
                if (userResult.error == false) {
                    setGetAllUserList(userResult.data)
                    setShowTable(true)
                }
                else {
                    Swal.fire(userResult.message)
                    if (userResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the user list", error);
            })
    }

    function getDetails() {
        const roleUsr = api.GetRoleUserDetails + '/' + designationId;
        fetch(roleUsr, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((usrResponse) => usrResponse.json())
            .then((usrResult) => {
                if (usrResult.error == false) {
                    setGetAllUserList(usrResult.data)
                }
                else {
                    Swal.fire(usrResult.message)
                    if (usrResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the user details", error)
            })
    }

    function exportReport() {
        if (!designationId) {
            Swal.fire("Please select the designation");
        } else {
            const formData = new FormData();
            formData.append("internalUserId", designationId);
            const exportRpt = api.ExportInternalUsersReport;
            fetch(exportRpt, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData,
            })
                .then((exportReponse) => exportReponse.json())
                .then((exportResult) => {
                    if (exportResult.error == true) {
                        if (exportResult.code == 401) {
                            Utils.logoutUser();
                        }
                    } else {
                        const blob = new Blob([exportResult.data], { type: "application/vnd.ms-excel" });
                        const url = URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = "InternalUserReport.xls"; // Save file as .xls
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    }
                })
                .catch((error) => {
                    console.log("Failed to export Internal User Report", error);
                })
        }
    }

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">
                                    <i className="fa fa-university"></i>
                                    Internal User Report
                                </h3>
                            </div>
                            <div>
                                <Link
                                    to={routes.reports}
                                    className="btn btn-primary save-profile"
                                >
                                    <i className="fas fa-arrow-left"></i>Back
                                </Link>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="court-tab-content">
                                        <div className="court-tab-content">
                                            <div className="card card-tableset">
                                                <div className="card-body">
                                                    <div className="coache-head-blk">
                                                        <div className="row align-items-center">
                                                            <div className="row col-md-12">
                                                                <div className="row col-md-12 court-sortby sortbyset">
                                                                    <div className="col-md-5">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Select Designation</h6></label>
                                                                            <Select value={designationList.find(desig => desig.roleId === designationId) ? {
                                                                                value: designationId,
                                                                                label: designationList.find(desig => desig.roleId === designationId).roleName
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setDesignationId(e.value)
                                                                                    getUserData(e.value)
                                                                                }}
                                                                                options={designationList.map(desig => ({
                                                                                    value: desig.roleId,
                                                                                    label: desig.roleName
                                                                                }))}
                                                                                placeholder={"Select a Designation"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-2 mt-4">
                                                                        <h3>------OR------</h3>
                                                                    </div>
                                                                    <div className="col-md-5">
                                                                        <div className="save-changes text-center text-sm mt-4">
                                                                            <Button onClick={getDetails}>Submit</Button>
                                                                            <Button onClick={exportReport}>Export to Excel</Button>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    showTable && (
                                                        <>
                                                            <div className="row col-md-12" style={{ overflowX: "scroll" }}>
                                                                <table className="table datatable">
                                                                    <thead className="thead-light">
                                                                        <th className="text-center text-uppercase">Sl No</th>
                                                                        <th className="text-center text-uppercase">Name</th>
                                                                        <th className="text-center text-uppercase">Date of Birth</th>
                                                                        <th className="text-center text-uppercase">Phone</th>
                                                                        <th className="text-center text-uppercase">Email</th>
                                                                        <th className="text-center text-uppercase">Designation</th>
                                                                        <th className="text-center text-uppercase">Coach For</th>
                                                                        <th className="text-center text-uppercase">Joining Date</th>
                                                                        <th className="text-center text-uppercase">Address</th>
                                                                        <th className="text-center text-uppercase">User Name</th>
                                                                        <th className="text-center text-uppercase">Password</th>
                                                                    </thead>
                                                                    <tbody>
                                                                        {Array.isArray(getAllUserList) && getAllUserList.map((usr, index) => (
                                                                            <tr key={index}>
                                                                                <td className="text-center">{index + 1}</td>
                                                                                <td className="text-center">{usr.internalUserName}</td>
                                                                                <td className="text-center">{formatDate(usr.internalUserBirthDate)}</td>
                                                                                <td className="text-center">{usr.internalUserPhone}</td>
                                                                                <td className="text-center">{usr.internalUserEmail}</td>
                                                                                <td className="text-center">{usr.roleName}</td>
                                                                                <td className="text-center">{usr.sportName}</td>
                                                                                <td className="text-center">{formatDate(usr.internalUserJoiningDate)}</td>
                                                                                <td className="text-center">{usr.internalUserAddress}</td>
                                                                                <td className="text-center">{usr.username}</td>
                                                                                <td className="text-center">{usr.internalUserPassword}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InternalUserReport;